import {setRef} from '@esgi/ui-kit/utils';
import {ReactNode, useEffect, useRef} from 'react';
import {ElementsNavigator, NavigatorManager} from '../elements-navigator';

type Props = {
	disable?: boolean;
	children?: ReactNode;
}

export function ArrowNavigation({disable, children}: Props): JSX.Element {
	const isDisabled = useRef();
	setRef(disable, isDisabled);

	const navigator = useRef<NavigatorManager>();

	useEffect(() => {
		const handler = (e: KeyboardEvent) => {
			if (isDisabled.current) {
				return;
			}

			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				let moved: boolean;
				if (e.key === 'ArrowUp') {
					moved = navigator.current?.back();
				} else {
					moved = navigator.current?.forward();
				}

				if (moved) {
					e.preventDefault();
					e.stopPropagation();
				}
			}
		};

		document.addEventListener('keydown', handler);
		return () => document.removeEventListener('keydown', handler);
	}, [navigator, isDisabled]);

	return <ElementsNavigator navigatorManager={navigator}>
		{children}
	</ElementsNavigator>;
}
